import { Command } from 'commander'

import { ListCommand } from './list'
import { SetCommand } from './set'

const teamCommands = [ListCommand, SetCommand]

const teamDomain = new Command('team')
teamDomain.description('Manage user teams')
teamCommands.forEach((command) => teamDomain.addCommand(command()))
export default teamDomain
